import ConfirmationDialog from 'civic-champs-shared/core/confirm-dialog/ConfirmDialog'
import React from 'react'

export const ConfirmLeaveQuestionnaireDialog = ({ showing, close, complete }: any) => (
  <ConfirmationDialog
    showing={showing}
    close={() => close()}
    complete={() => complete(true)}
    title="Leave without saving?"
    text="You have unsaved changes to this questionnaire. If you leave now, your changes will be lost."
    cancelText="Continue Editing"
    confirmText="Leave Without Saving"
    type="warning"
  />
)

export default ConfirmLeaveQuestionnaireDialog
